<template>
    <div class="search-box">
        <el-select v-model="currViewName" v-show="type !== 'agentmaterial'" @change="changeView" class="m-2" placeholder="搜索" size="large" style="width: 5em;">
            <el-option
                    v-for="n in viewList"
                    :key="n.key"
                    :label="n.key"
                    :value="n.value"
            />
        </el-select>
        <el-input
                v-model="keyword"
                class="search-input"
                size="large"
                placeholder="搜索..."
                clearable
                v-loading="loadingFlag"
                @change="changeKeyword"
        />
        <el-button
            :icon="Search"
            size="large"
            v-loading="loadingFlag"
            @click="changeKeyword"
        />
    </div>

    <div class="type-toggle-box">
        <div>
            <ProductTypeTreeSelect
                v-model="selectedType"
                v-show="currViewName === 'material'"
                v-loading="loadingFlag"
                @changeSelect="changeProductType"
            />
            <span>&nbsp;</span>
        </div>

        <ListDisplayToggle
            :type="viewType"
            @clickBtn="changeViewType"
        />
    </div>

    <div class="search-result" v-infinite-scroll="scrollLoadFunc">
        <el-row :gutter="10">
            <el-col
                :span="cols"
                v-for="(value, index) in materialList"
                :key="value.id"
                class="record-box"
            >
                <SearchMaterialResult
                    :obj="value"
                    :title="value.company.companyname"
                    :titleDes="`${value.company.wa}-${value.company.siojournal}`"
                    :imgUrl="myUtil.generateProductImg(value)"
                    :name="value.productname"
                    :description="value.description"
                    :cost="value.cost"
                    :btn-label="type ==='agentmaterial'?i18n.tkey('lang_agent_request'):i18n.tkey('lang_go_shop_view')"
                    :tag="viewType"
                    :type="props.type"
                    @click-go-shop="materialGoShop"
                />
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col
                :span="cols"
                v-for="(value, index) in companyList"
                :key="value.id"
                class="record-box"
            >
                <shopResultComponent :obj="value" @click-go-shop="goShop" />
            </el-col>
        </el-row>

        <el-empty
            :description="i18n.tkey('lang_temporary_no_data')"
            v-show="materialList.length == 0 && companyList.length == 0"
        />

        <div v-show="false">
            <PaginationComponent
                :pageObj="pageObj"
                @goPage="changePage"
                style="border-top: 0"
            />
        </div>
    </div>
</template>

<script setup>
import {getCurrentInstance, ref, onMounted, onBeforeMount, inject, toRef} from 'vue'
    import {Search} from '@element-plus/icons-vue';
    import shopResultComponent from '@/components/phone/shopResultComponent.vue'
    import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
    import SearchMaterialResult from "@/components/shopopee/dataDisplay/searchMaterialResult.vue";
    import companyApi from "@/request/companyApi";
    import materialApi from "@/request/materialApi";
    import myUtil from "@/util/util";
    import ListDisplayToggle from "@/components/shopopee/common/listDisplayToggle.vue";
    import ProductTypeTreeSelect from "@/components/shopopee/whatsShopsBCata/productTypeTreeSelect.vue";

    const emits = defineEmits(['go-shop', "changeView"])
    const props = defineProps(['type','materialObj', "keyword", "viewList", "viewName"])

    let { proxy } = getCurrentInstance();
    const i18n = inject("i18n")

    const keyword = ref("")
    const selectedType = ref(null)
    const materialList = ref([])
    const companyList = ref([])
    const loadingFlag = ref(false)
    const currViewName = ref("material")
    const viewType = ref("block")

    const cols = ref(12)

    let pageNum = 1
    let pageSize = 10
    const pageObj = ref({})

    function changeKeyword() {
        if (pageNum === 1){
            companyList.value = []
            materialList.value = []
        }

        loadingFlag.value = true
        if(props.type === "agentmaterial"){
          if (currViewName.value === "total" || currViewName.value === "material"){
            queryMaterialByPage(queryMaterialCallback)
          }

          if (currViewName.value === "total" || currViewName.value === "shop"){
            queryCompanyByPage(queryCompanyCallback)
          }
        }else {
          if (currViewName.value === "total" || currViewName.value === "material"){
              queryMaterialByPage(queryMaterialCallback)
          }

          if (currViewName.value === "total" || currViewName.value === "shop"){
              queryCompanyByPage(queryCompanyCallback)
          }
        }
    }


    async function queryCompanyByPage(callback) {
        const request = companyApi.getCompany3DInfoByPage
        const params = request.getParams()

        params.companyname = keyword.value
        params.pageNum = pageNum
        params.pageSize = 40

        request.send(params, (res) => {
            loadingFlag.value = false
            if (typeof callback === "function"){
                callback(res)
            }
        })

    }

    function queryCompanyCallback(detail) {
        if (null != detail && detail.code === 200){
            // companyList.value = detail.detail.list
            companyList.value = companyList.value.concat(detail.detail.list)

            changePageObj(detail.detail)

        }else{
            companyList.value = []
        }
    }

    async function queryMaterialByPage(callback) {

        const request = materialApi.queryMaterialAndCompanyByPage
        const params = request.getParams()

        params.productname = keyword.value
        params.bcatacode2 = selectedType.value
        params.pageNum = pageNum
        params.pageSize = pageSize
        if(props.type === "agentmaterial") {
          params.postype = -1
        }

        request.send(params, (res) => {
            loadingFlag.value = false
            if (typeof callback === "function"){
                callback(res)
            }
        })

    }

    function queryMaterialCallback(detail) {
        if (null != detail && detail.code === 200){
            // materialList.value = detail.detail.list
            materialList.value = materialList.value.concat(detail.detail.list)

            changePageObj(detail.detail)
        }else{
            materialList.value = []

            // myUtil.alertError(detail.msg)
        }
    }

    function goShop(wa, siojournal, islandid) {
        emits("go-shop", wa, siojournal, islandid)
    }

    function materialGoShop(obj){
      if(props.type === "agentmaterial"){
        const shareStr=  `${proxy.$ShopopeeUrl}productInfo?id=${obj.id}`
        window.location.href=shareStr
      }else{
        emits("go-shop", obj.company.wa, obj.company.siojournal, obj.company.islandid)
      }
    }

    function changeView(){
        // emits("changeView", currViewName.value, keyword.value)
        selectedType.value = null
        changePage(1)
    }

    function changeProductType(){
        changePage(1)
    }

    function changePage(num){
        pageNum = num
        changeKeyword()
    }

    function changePageObj(obj){
        if (null == pageObj.value.total || obj.total > pageObj.value.total || obj.pageNum != pageObj.value.pageNum){
            pageObj.value = obj
        }
    }

    function changeViewType(name){
        viewType.value = name

        if (name === "block"){
            if (myUtil.isMobile()){
                cols.value = 12
            }else{
                cols.value = 6
            }
        }else{
            cols.value = 24
        }
    }

    function scrollLoadFunc(){
        if (null != pageObj.value.hasNextPage && pageObj.value.hasNextPage === true){
            changePage(pageNum + 1)
        }
    }

    onMounted(() => {
        // currViewName.value = props.viewName

        if (null != props.keyword){
            keyword.value = props.keyword
        }

        changeKeyword()
    })

    onBeforeMount(() => {

      if (props.type === "material"||props.type === "agentmaterial"){

      }
        if (!myUtil.isMobile()){
            cols.value = 6
        }

    })

</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }



    .search-result {
        width: 100%;
        height: calc(100% - 110px);
        padding: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .record-box {
        margin-bottom: 10px;
    }

    .type-toggle-box {
        text-align: right;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    @media screen and (max-width: 520px) {
        .search-box {
            text-align: center;
            width: 80%;
            margin: auto;
            box-sizing: border-box;
            padding: 10px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    @media screen and (min-width: 520px) {
        .search-box {
            text-align: center;
            width: 50%;
            margin: auto;
            box-sizing: border-box;
            padding: 10px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .search-input {
        width: calc(100% - 110px);
    }

</style>